<template>
    <div>
        <h4>Paramètres des sondages</h4>
        <vx-card class="mt-5" title="Trame des analyses">
            <CampaignQuestionnaires api="/api/referentiel/campaign-questionnaires" />
        </vx-card>
        <vx-card class="mt-5" title="Trame des synthèses">
            <CampaignFields api="/api/referentiel/campaign-fields" />
        </vx-card>
        <vx-card class="mt-5" title="Type de campagne">
            <CampaignTypes api="/api/referentiel/campaign-types" />
        </vx-card>
    </div>
</template>

<script>

import CampaignQuestionnaires from './CampaignQuestionnaires.vue';
import CampaignFields from "./CampaignFields.vue"
import CampaignTypes from "./CampaignTypes.vue"
export default {
    name: "CampaignParameters",
    components: {
        CampaignQuestionnaires,
        CampaignFields,
        CampaignTypes
    },
    data() {
        return {

        };
    },

    created() {

    },

    computed: {

    },

    watch: {

    },

    methods: {

    }
};
</script>

<style scoped>

</style>
